import { MDCTextField } from '@material/textfield';

//import { MDCFormField } from "@material/form-field";
import { MDCRadio } from "@material/radio";
import { MDCCheckbox } from "@material/checkbox";
import { MDCTextFieldCharacterCounter } from '@material/textfield/character-counter';
import { MDCSelect } from '@material/select';
import {MDCChipSet } from '@material/chips';


const mdcInputs = [];

/**
 * Auto-format phone number fields
 * @param elem
 * @private
 */
const formatPhoneField = (elem) => {
    const filter = [];

    // Add keys that might be needed for navigation
    // or for editing the keyboard input
    filter.push(8);     //backspace
    filter.push(9);     //tab
    filter.push(46);    //delete
    filter.push(37);    //left arrow
    filter.push(39);    //right arrow

    // On keydown if not a number, a hyphen, or navigation do not allow
    elem.addEventListener('keydown', (ev) => {
        // Stop from going too long
        if (elem.value.length > 12) {
            ev.preventDefault();
        }

        // Only allow certain characters
        if (Number(isNaN(ev.key)) === 1 && (ev.key !== '-' && filter.indexOf(ev.keyCode) < 0)) {
            ev.preventDefault();
        }

    });

    // On keyup format and validate
    elem.addEventListener('keyup', () => {
        let value = elem.value.trim();

        value = value.replace(/-/g,'');

        if (value.length > 3 && value.length <= 6) {
            value = value.slice(0,3) + "-" + value.slice(3);
        } else if (value.length > 6) {
            value = value.slice(0,3) + "-" + value.slice(3,6) + "-" + value.slice(6);
        }

        elem.value = value;
    }, true);
}

/**
 * Initialize elements
 * @param element
 * @private
 */
const setupInputs = (element) => {
    // Setup Material Design input components
    element.querySelectorAll('.mdc-text-field').forEach( (elem) => {
        const mdc = new MDCTextField(elem);

        // Set for reference later if needed
        mdcInputs[elem.getAttribute('for')] = mdc;

        // Custom field validation
        const native = elem.querySelector('.mdc-text-field__input');

        // Live validate password_confirm field
        if (native.name === 'password_confirm') {
            native.addEventListener('change', () => {
                const original = element.querySelector('input[name="password"]');
                if (native.value !== original.value) {
                    native.setCustomValidity('Passwords must match.');
                    mdc.valid = false;
                } else {
                    native.setCustomValidity('');
                    mdc.valid = true;
                }
            }, true);
        }

        // Add character count to textarea
        if (native.tagName === 'textarea') {
            const characterCounter = new MDCTextFieldCharacterCounter(elem.querySelector('.mdc-text-field-character-counter'));
        }

        // Live format the phone number field
        if (native.classList.contains('phone-input-field')) {
            formatPhoneField(native);
        }
    })

    element.querySelectorAll('.mdc-radio').forEach( (elem) => {
        mdcInputs[elem.id] = new MDCRadio(elem);
    })

    element.querySelectorAll('.mdc-checkbox').forEach( (elem) => {
        mdcInputs[elem.id] = new MDCCheckbox(elem);
    })

    element.querySelectorAll('.mdc-select').forEach( (elem) => {
        mdcInputs[elem.id] = new MDCSelect(elem);
    })

    element.querySelectorAll('.mdc-evolution-chip-set').forEach( (elem) => {
        const chipSet = new MDCChipSet(elem);

        mdcInputs[elem.id] = chipSet;

        chipSet.listen('MDCChipSet:selection', (ev: any) => {
            const input = elem.querySelector('#' + ev.detail.chipID + ' input');
            if (input) {
                input.checked = ev.detail.isSelected;
            }
        })
    })
}

export { mdcInputs, setupInputs }